<template>
  <div class="card overflow-hidden position-relative">
    <div class="card-body overflow-hidden">
      <div class="font-size-36 font-weight-bold text-dark mb-n2">
        {{ Math.round(channelData.usage_percentage)
        }}<i class="fa fa-percent icon-large"></i>
      </div>
      <div class="text-uppercase">
        {{ common.handleChannelName(channelData.name) }}
      </div>
      <div class="card-over-flow-icon">
        <i
          :class="common.getSocialIcon(channelData.slug).class"
          :style="{
            color: `${common.getSocialIcon(channelData.slug).colorHexa} !important`,
            backgroundColor: 'transparent !important',
            opacity: '30%'
          }"
        ></i>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@/utils/analytics/common'
export default {
  name: 'channelPrecentage',
  components: {},
  data() {
    return {
      common
    }
  },
  props: {
    channelData: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
<style src="@/assets/css/bs-helpers.css" lang="css" scoped/>
<style>
.card-over-flow-icon {
  position: absolute;
  right: -25px;
  bottom: -85px;
  font-size: 110px;
}
.icon-large {
  font-size: 18px;
}
</style>
